export default function CTA() {
  return (
    <section id="contact" className="py-32 md:py-40 px-6 bg-white">
      <div className="max-w-xl md:max-w-2xl mx-auto text-center">
        
        {/* Group 1: The Status */}
        <div className="mb-20 md:mb-28">
          <p className="text-xs md:text-sm tracking-[0.3em] text-gray-400 uppercase mb-8">
            今できること —
          </p>
          <p className="text-lg md:text-2xl font-medium text-gray-900 leading-relaxed">
            <span className="font-semibold">BAILA BAILA</span> <span className="font-light opacity-80">MOVE</span> は、<br />
            今動き始めました。
          </p>
        </div>

        {/* Group 2: The Process */}
        <div className="mb-20 md:mb-28">
          <p className="text-sm md:text-lg font-light text-gray-600 leading-[2.2] md:leading-relaxed">
            コンセプト、動きの考え方、<br />
            プログラムの構造を、<br />
            少しずつ公開しています。
          </p>
        </div>

        {/* Group 3: The Future */}
        <div className="mb-20 md:mb-28">
          <p className="text-base md:text-xl font-medium text-gray-900 mb-8">
            これから起こること
          </p>
          <div className="text-xs md:text-base font-light text-gray-600 leading-[2.0] md:leading-relaxed space-y-6">
            <p>
              少人数での体験レッスンを<br />
              オンライン・オフライン両方の形式で開催予定です。
            </p>
            <p>
              シンプルな動きから始まり、<br />
              振付を通じて<br />
              自然に表現へと導くプログラムです。
            </p>
          </div>
        </div>

        {/* Group 4: The CTA */}
        <div>
          <p className="text-sm md:text-lg font-light text-gray-600 leading-relaxed mb-10">
            スケジュールの詳細は、<br />
            早期参加者の方々に共有します。
          </p>
          
          <div className="flex justify-center mb-6">
            <a
              href="https://lin.ee/8MPcXbb"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-3 md:px-12 md:py-4 bg-[#06C755] text-white text-base md:text-xl font-light leading-normal rounded-full hover:bg-[#05b34c] transition-all cursor-pointer whitespace-nowrap max-w-[280px] md:max-w-none w-auto"
            >
              LINEで体験の案内を受け取る
            </a>
          </div>
          
          <p className="text-xs font-light text-gray-400 leading-relaxed">
            早期情報と体験セッションの案内を受け取ります。<br />
            販売はありません。義務もありません。
          </p>
        </div>
        
      </div>
    </section>
  );
}
